var showInstallPromotion = false;
var deferredPrompt;

a.init = (function(){
	var my = {
		init:function(){
			a.auth.authorize();
			// Get session info and assing to vars
			my.getSessionInfo(function(){
				a.router.init();
			});
			// App install prompt
			window.addEventListener('beforeinstallprompt', (e) => {
				// Prevent the mini-infobar from appearing on mobile
				e.preventDefault();
				// Stash the event so it can be triggered later.
				deferredPrompt = e;
				// Update UI notify the user they can install the PWA
				showInstallPromotion = true;
				// Show box
				$('.installapp').show();
			});
			my.checkForUpdate();
		},
		getSessionInfo:function(cb_done){
			$.ajax({
				type:'GET',
				url:'/api/sessioninfo/',
				data:{
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						a.accountinfo = result.accountinfo;
						a.userinfo = result.userinfo;
						cb_done();
					}
				}
			}).done(function(){});
		},
		checkForUpdate:function(){
			$.ajax({
				type:'GET',
				url:'/api/version/',
				data:{},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (!isNaN(result['v']) && !isNaN(v)) {
						if (result['v']!==v) {
							a.loader.fs.create();
							caches.keys().then(function(cacheNames) {
								return Promise.all(
									cacheNames.map(function(cacheName) {
										return caches.delete(cacheName);
									})
								);
							});
							setTimeout(function(){
								my.showUpdatedWindow();
								a.loader.fs.remove();
							},200);
						}
					}
				}
			}).done(function(){});
		},
		showUpdatedWindow:function(){
			if (confirm('The app has been updated. Press OK to continue.')) {
				location.reload();
			}
		}
	}
	return my;
}());
a.init.init();